const NON_CLICK_EVENT = 'non_click_event';
const XS = 'xs';
const addToDataLayer = props => {
  var _a;

  const {
    event,
    eventCategory,
    eventAction,
    eventLabel
  } = props;
  (_a = window === null || window === void 0 ? void 0 : window.dataLayer) === null || _a === void 0 ? void 0 : _a.push({
    event: event,
    event_category: eventCategory,
    event_action: eventAction,
    event_label: eventLabel
  });
};
const addXSEventToDataLayer = props => {
  const {
    eventAction,
    eventLabel
  } = props;
  addToDataLayer({
    event: NON_CLICK_EVENT,
    eventCategory: XS,
    eventAction,
    eventLabel
  });
};

class GUA {
  constructor() {
    this.name = 'Universal Analytics';
    this.featureIds = new Set();
    this.featureNames = new Set();
    this.variationsIds = new Set();
    this.variationNames = new Set();

    this.onExposure = feature => {
      if (window && window.digital_data) {
        const {
          featureId,
          featureTextId,
          variationId,
          variationName
        } = feature;
        this.featureIds.add(featureId);
        this.featureNames.add(featureTextId);
        this.variationsIds.add(`${featureId}:${variationId}`);
        this.variationNames.add(`${featureTextId}:${variationName}`);
        window.digital_data.experiments_ids = Array.from(this.featureIds).join(',');
        window.digital_data.experiments_names = Array.from(this.featureNames).join(',');
        window.digital_data.variants_ids = Array.from(this.variationsIds).join(',');
        window.digital_data.variant_names = Array.from(this.variationNames).join(',');
        addXSEventToDataLayer({
          eventAction: `${featureTextId}:${featureId}`,
          eventLabel: `${variationName}:${variationId}`
        });
      }
    };
  }

}

export { GUA as default };
